import { api } from './api';
import { transformAllRubricModel } from '../../components/shared/transformData/transform-rubric-camp-event';

const rubricUrl = '/rubric';

export const rubricApi = api.injectEndpoints({
  endpoints: builder => ({
    getAllRubrics: builder.query({
      query: () => `${rubricUrl}`,
      providesTags: ['Rubric'],
    }),
    createRubric: builder.mutation({
      query: body => {
        return {
          url: `${rubricUrl}`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: ['Rubric'],
    }),
    getAllRubricsByCampAndEvent: builder.mutation({
      query: body => {
        return {
          url: `${rubricUrl}/rubricAssignation`,
          method: 'POST',
          body,
        };
      },
      transformResponse: response => (response || []).map(transformAllRubricModel),
    }),
    assignRubricsToJudges: builder.mutation({
      query(body) {
        return {
          url: `${rubricUrl}/rubricAssignation`,
          method: 'PUT',
          body,
        };
      },
      invalidatesTags: ['Rubric'],
    }),
    getRubric: builder.query({
      query: id => `${rubricUrl}/${id}`,
    }),
    assignJudges: builder.mutation({
      query: ({ id, body }) => {
        return {
          url: `${rubricUrl}/${id}`,
          method: 'PUT',
          body,
        };
      },
      invalidatesTags: ['Rubric'],
    }),
    removeJudgeFromRubric: builder.mutation({
      query(body) {
        return {
          url: `${rubricUrl}/removeJudge`,
          method: 'DELETE',
          body,
        };
      },
      invalidatesTags: ['Rubric', 'User'],
    }),
    removeAllJudgeFromRubric: builder.mutation({
      query(body) {
        return {
          url: `${rubricUrl}/removeAllJudges`,
          method: 'DELETE',
          body,
        };
      },
      invalidatesTags: ['Rubric'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAllRubricsQuery,
  useCreateRubricMutation,
  useGetAllRubricsByCampAndEventMutation,
  useAssignJudgesMutation,
  useAssignRubricsToJudgesMutation,
  useRemoveJudgeFromRubricMutation,
  useRemoveAllJudgeFromRubricMutation,
} = rubricApi;
